import './DashboardEmpty.css';
import React, { useContext } from 'react';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
var DashboardEmpty = function DashboardEmpty(_ref) {
  var children = _ref.children;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-empty ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-empty__icon"
  }, /*#__PURE__*/React.createElement(EmptyIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-empty__text"
  }, children));
};
var EmptyIcon = function EmptyIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "67",
    height: "74",
    viewBox: "0 0 67 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-svgrepo-com",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7150",
    "data-name": "Path 7150",
    d: "M3,44V30C3,16.8,3,10.2,7.1,6.1S17.8,2,31,2h7C51.2,2,57.8,2,61.9,6.1c2.286,2.286,3.3,5.349,3.745,9.9M66,30V44c0,13.2,0,19.8-4.1,23.9S51.2,72,38,72H31c-13.2,0-19.8,0-23.9-4.1C4.814,65.613,3.8,62.55,3.355,58",
    transform: "translate(0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7151",
    "data-name": "Path 7151",
    d: "M8,14H25.555",
    transform: "translate(12.479 30)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7152",
    "data-name": "Path 7152",
    d: "M8,10h3.511m24.577,0H22.044",
    transform: "translate(12.456 20)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "4"
  })));
};
export default DashboardEmpty;
var commonStyles = "c1uf34gg";
var ltrStyles = "l17yn4wd";
var rtlStyles = "r1qity7f";